import { render } from "./diabetes_history.vue?vue&type=template&id=564801ca&scoped=true"
import script from "./diabetes_history.vue?vue&type=script&lang=js"
export * from "./diabetes_history.vue?vue&type=script&lang=js"

import "./diabetes_history.vue?vue&type=style&index=0&id=564801ca&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564801ca"]])

export default __exports__